import { type Hash } from 'history';
import { matchPath } from 'react-router';

const tokenLoginMatcher = (hash: Hash) => {
  const path = hash.substring(1);
  const [pathname, search] = path.split('?');
  const match = matchPath('/token-login/:userId/:token', pathname);
  if (!match) return null;
  const email = new URLSearchParams(search).get('email');
  return {
    ...match.params,
    email: email ? decodeURIComponent(email) : undefined,
  };
};

export default tokenLoginMatcher;
